<template>
  <div>
    <span :style="{backgroundColor: bgColor, color: textColor, borderRadius: '3px', paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px'}">
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      required: false,
      default: '#000000'
    },
    textColor: {
      type: String,
      required: false,
      default: '#ffffff'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tags/index.vue